module.exports = {
  __init__: [ 'modeling', 'bpmnUpdater', 'bpmnLabelSupport' ],
  __depends__: [
    require(14),
    require(34),
    require(29),
    require(80),
    require(168),
    require(112),
    require(91),
    require(159),
    require(98)
  ],
  bpmnFactory: [ 'type', require(15) ],
  bpmnUpdater: [ 'type', require(18) ],
  elementFactory: [ 'type', require(19) ],
  modeling: [ 'type', require(20) ],
  bpmnLabelSupport: [ 'type', require(16) ],
  layouter: [ 'type', require(17) ],
  connectionDocking: [ 'type', require(173) ]
};
